




























































import GlobalMixin from "@/shared/mixins/globalMixin";
import { Faq, FaqsService } from "@/services/faqs.service";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import ComboTopicos from "./ComboTopicos.vue";
import draggable from "vuedraggable";

import "@/shared/array";

@Component({
  components: { ComboTopicos, draggable },
})
export default class AlterarOrdem extends mixins(GlobalMixin) {
  idTopico: number | null = null;
  faqs: Faq[] | null = null;

  mounted() {
    let dump = 0;
    if (
      this.$route.params.id &&
      !Number.isNaN((dump = +this.$route.params.id))
    ) {
      this.mudarTopico((this.idTopico = dump));
    }
  }

  voltar() {
    this.$router.push({ name: "faqs" });
  }

  async mudarTopico(idTopico: number | null) {
    if (idTopico) {
      this.startLoader();
      const response = await FaqsService.ListaAlterarOrdem(idTopico).finally(
        this.stopLoader
      );
      this.faqs = response.orderByDescending((x) => x.ativo).toArray();
      this.faqs.forEach((value, i) => {
        value.pergunta = i + 1 + " - " + value.pergunta;
      });
    }
  }

  salvarOrdem() {
    if (this.idTopico && this.faqs) {
      this.startLoader();
      FaqsService.AlterarOrdem(
        this.idTopico,
        this.faqs.map((x) => x.idFaq)
      )
        .then(() => {
          this.voltar();
        })
        .finally(this.stopLoader);
    }
  }
}
